const NUMBER_UNITS = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
const TEN_UNITS = ['', '십', '백', '천'];
const THOUSAND_UNITS = ['', '만', '억', '조', '경', '해'];

// 배열 쪼개기
function chunkAtEnd(value: string, n: number) {
  const result: string[] = [];

  for (let end = value.length; end > 0; end -= n) {
    result.push(value.substring(Math.max(0, end - n), end));
  }

  return result;
}

// 모든 숫자 바꾸기
export function numberToKorean(number: string) {
  if (number === '') {
    return '-';
  }
  if (Number(number) === 0) {
    return '영';
  }
  return chunkAtEnd(number, 4)
    .reduce((acc, item, index) => {
      if (!Number(item)) {
        return acc;
      }

      let numberUnit = '';

      const zeroNum = item.padStart(4, '0');

      for (let i = 0; i < 4; i++) {
        const number = Number(zeroNum[i]);

        if (number) {
          const unit = TEN_UNITS[3 - i];

          numberUnit += `${unit && number === 1 ? '' : NUMBER_UNITS[number]}${unit}`;
        }
      }

      const thousandUnit = THOUSAND_UNITS[index] ?? '';

      return `${numberUnit + thousandUnit}${acc}`;
    }, '')
    .trim();
}
